import { FC, JSX } from "react";
import { Spinner } from "@radix-ui/themes";
import { useSingleEvent } from "../../hooks/useSingleEvent";
import EventSingleUI from "./event.single.ui";

interface EventSingleFetcherProps {
  slug: string;
}

const EventSingleFetcher: FC<EventSingleFetcherProps> = ({
  slug,
}): JSX.Element | null => {
  const { data, loading, error } = useSingleEvent(slug);

  if (loading) return <Spinner />;

  if (error) {
    return <>Error: {error.message}</>;
  }

  if (data) {
    return <EventSingleUI {...data} />;
  }
  return null;
};

export default EventSingleFetcher;
